<div class="flex flex-col items-center justify-center h-screen text-center px-4">
  <h1 class="text-3xl font-bold text-red-600 mb-4">{{ title }}</h1>
  <p class="text-lg text-gray-700 mb-6">{{ message }}</p>
  <!-- <button
    (click)="backToHome()"
    class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-all duration-300"
  >
    Back to Home
  </button> -->
</div>
